export const DATA_HC_NAME_PAGE_AUTH_SPINNER = 'page-authorization-spinner';
export const HC_ORG_ID = 1;
